// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/88055b6304b7a95b0af7.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"321bc127c7be567d8d2f","159":"e0bd43b3c988e55b2724","160":"129b592747fd83a66d3b"}[chunkId] + ".chunk.js";
};